/// <amd-module name="VSSUI/VssIcon" />
export * from "./Components/VssIcon/index";
